import { useState, useEffect, useCallback, useRef,useImperativeHandle } from "react";
import { ReactDiagram } from "gojs-react";
import { tubeColorSet } from "@/config/const";
import * as go from "gojs";
import LinkLabelOnPathDraggingTool from "./LinkLabelOnPathDraggingTool";
import {
  Modal,
  Button,
  message,
  Popconfirm,
  Table,
  Input,
  Select,
  Form,
  Drawer,
  Tooltip,
  ColorPicker,
} from "antd";
import Dialog from "rc-dialog";
import Draggable from "react-draggable";
import "rc-dialog/assets/index.css";
import { loadOverview } from "./func";
// import './GuidedDraggingTool';
import { PlusCircleOutlined, DeleteOutlined,WarningOutlined } from "@ant-design/icons";
import { useAppContext } from "@/AppContext";
import { rebuildFormula } from "@/config/func";
import { unitMap,materialsValueMap } from "@/constants/dataMap";
import ParameterEditor from "./ParameterEditor";

import element from "./newElements.json";
import boiler from "./elementsData/boiler.json";
import comments from "./elementsData/comments.json";
import container from "./elementsData/container.json";
import equipment from "./elementsData/equipment.json";
import heatExchanger from "./elementsData/heatExchanger.json";
import others from "./elementsData/others.json";
import products from "./elementsData/products.json";
import pump from "./elementsData/pump.json";
import reactor from "./elementsData/reactor.json";
import separator from "./elementsData/separator.json";
import tank from "./elementsData/tank.json";
import tower from "./elementsData/tower.json";
import Flash2 from "./elementsData/Flash2.json";
import { stringify } from "querystring";
import test_Rectisol from "@/constants/test_Rectisol.json";

interface DataSource {
  nodeDataArray: any;
  linkDataArray: any;
}

interface ComponentProps {
  overview?: boolean; //是否显示概览图
  dataSource: DataSource; //流程图数据
  settings?: Settings; //其他设置
  diagrams: any;
  setDiagrams: any;
  globalData?: any;
  onScaleChange?: (scale: number) => void;
  diagramsRef:any
}

interface Settings {
  readonly?: boolean; //是否只读
}

const elementsDatas = {
  boiler: boiler,
  comments: comments,
  container: container,
  equipment: equipment,
  ShellAndTubeExchanger: heatExchanger,
  others: others,
  products: products,
  pump: pump,
  reactor: reactor,
  Splitter: separator,
  tank: tank,
  DistilStrict: tower,
  Flash2:Flash2,
};

export const getStreamsBasicParams = () => [
  {
    p_name: "类型",
    p_engName: "type",
    p_show: true,
    enum: [
      { label: "进料", value: "进料" },
      { label: "出料", value: "出料" },
      { label: "内部", value: "内部" },
    ],
  },
  {
    p_name: "物性计算方法",
    p_engName: "physical_method",
    p_show: true,
    enum: [
      { label: "NRTL-RK", value: "NRTL" },
      { label: "SRK", value: "SRK" },
    ],
  },
  {
    p_name: "相态",
    p_engName: "phase",
    p_show: true,
    enum: [
      { label: "L-液相", value: "L" },
      { label: "V-汽相", value: "V" },
      { label: "VL-汽液两相", value: "VL" },
    ],
  },
  {
    p_name: "计算模式",
    p_engName: "mode",
    p_show: true,
    enum: [
      { label: "TP-温压闪蒸", value: "TP" },
      { label: "VP-汽化率压力闪蒸", value: "VP" },
      { label: "HP-压焓闪蒸", value: "HP" },
    ],
  },
  {
    p_name: "流股属性",
    p_engName: "streamAttribute",
    p_show: true,
    enum: [
      { label: "无", value: "无" },
      { label: "冷流股", value: "冷流股" },
      { label: "热流股", value: "热流股" },
    ],
  },
  { p_name: "流量", p_engName: "f", p_show: true, p_unitField: "", p_unit: ["kg/h"],p_value: "16500.19495" },
  { p_name: "温度", p_engName: "t", p_show: true, p_unitField: "", p_unit: unitMap["T"],p_value: "120" },
  { p_name: "压力", p_engName: "p", p_show: true, p_unitField: "", p_unit: unitMap["P"],p_value: "50.49" },
];

// 辅助函数：根据节点数据构建 modal2Data (基础信息)
export const buildNodeModal2Data = (nodeData: any) => {
  return {
    元件名称: { value: nodeData.nodeName, engName: "nodeName", show: true },
    物性计算方法: {
      value: nodeData.physical_method !== undefined ? nodeData.physical_method : "NRTL",
      engName: "physical_method",
      show: true,
      enum: [
        { label: "NRTL-RK", value: "NRTL" },
        { label: "SRK", value: "SRK" },
      ],
    },
    相态: {
      value: nodeData.phase !== undefined ? nodeData.phase : "L",
      engName: "phase",
      show: true,
      enum: [
        { label: "L-液相", value: "L" },
        { label: "V-汽相", value: "V" },
        { label: "VL-汽液两相", value: "VL" },
      ],
    },
    计算模式: {
      value: nodeData.mode !== undefined ? nodeData.mode : "TP",
      engName: "mode",
      show: true,
      enum: [
        { label: "TP-温压闪蒸", value: "TP" },
        { label: "VP-汽化率压力闪蒸", value: "VP" },
        { label: "HP-压焓闪蒸", value: "HP" },
      ],
    },
  };
};

// 根据节点数据构建 modalParams (参数列表)
export const buildNodeModalParams = (nodeData: any) => {
  const type = nodeData.type;
  const name = nodeData.elementName;
  let params: any[] = [];

  if (element.filter((item: any) => item.typeID == type).length > 0) {
    params = element.filter((item: any) => item.typeID == type)[0].params;
  }
  if (elementsDatas[type] !== undefined) {
    if (elementsDatas[type].filter((item: any) => item.name == name).length > 0) {
      let extraParams = elementsDatas[type].filter((item: any) => item.name == name)[0].params;
      if (extraParams.length > 0) {
        params = params.concat(extraParams);
      }
    }
  }

  // 根据 p_type 找单位
  for (let i = 0; i < params.length; i++) {
    if (params[i].p_type) {
      if (unitMap[params[i].p_type]) {
        params[i].p_unit = unitMap[params[i].p_type];
      }
    }
  }

  // 排序，有子的放最下面
  params = [
    ...params.filter((item: any) => !item.hasOwnProperty("p_children")),
    ...params.filter((item: any) => item.hasOwnProperty("p_children")),
  ];

  return params;
};

// 根据流股数据构建 modal2Data
export const buildLinkModal2Data = (linkData: any) => {
  return {
    流股名称: { value: linkData.linkName, engName: "linkName", show: true },
  };
};

// 根据流股数据和全局物质列表构建 materialsData
export const buildLinkMaterialsData = (linkData: any, globalMaterials: any[]) => {
  const newMaterialsData: any = {};
  for (let i = 0; i < globalMaterials.length; i++) {
    let name = globalMaterials[i].formula;
    newMaterialsData[name] = {
      molar_frac: linkData?.materials?.[name]?.molar_frac ?? "",
      desValue: linkData?.materials?.[name]?.desValue ?? (linkData?.materials?.[name]?.molar_frac ?? ""),
      cas: globalMaterials[i].cas_code,
      name: globalMaterials[i].formula,
      chineseName: globalMaterials[i].name,
    };
  }
  return newMaterialsData;
};

// 获取与节点相关的链接（入或出），用于 Ns/No 参数
export const getRelatedLinksFromData = (
  nodeKey: string,
  direction: "in" | "out",
  linkDataArray: any[]
) => {
  return linkDataArray.filter((link: any) => {
    if (direction === "in") return link.to === nodeKey;
    return link.from === nodeKey;
  });
};

export const getRelatedLinks2 = (nodeKey: string, direction: "cold" | "hot",linkDataArray: any[]) => 
  {
    let type = direction==="cold"?"冷流股":"热流股";
    return linkDataArray.filter((link) => 
    {
      return link.from === nodeKey && link.ParamValues?.["流股属性"]?.value===type;
    });
  };

// 初始化 localParamValues，类似于 Diagram 中 useEffect 里的逻辑
export const initializeLocalParamValues = (
  modalParams: any[],
  modal2Data: any,
  savedParamValues: any,
  nodeKey?: string,
  linkDataArray?: any[],
  selectNode?:string,
) => {
  const initialValues: any = {};
  modalParams.forEach((param: any) => {
    const paramName = param?.p_name;
    const saved = savedParamValues?.[paramName] || {};

    if (param.p_children && Array.isArray(param.p_children) && param.p_children.length > 0) 
    {
      if (param.p_engName === "Ns" || param.p_engName === "No" || param.p_engName === "output_f" ) 
      {
        if (nodeKey && linkDataArray) {
          const direction = param.p_engName === "Ns" ? "in" : "out";
          const links = getRelatedLinksFromData(nodeKey, direction, linkDataArray);
          const savedChildren = saved.p_children || [];
          const newChildren = links.map((link: any) => {
            const found = savedChildren.find((item: any) => item?.["流股"]?.value === (link.text || link.linkName));
            return {
              linkKey: link.key,
              streamName: link.text || link.linkName || "",
              value: found?.[param.p_engName === "Ns" ? "进料位置" : (param.p_engName === "No" ? "出料位置" : "输出流量")]?.value ?? (found?.[param.p_engName === "Ns" ? "进料位置" : (param.p_engName === "No" ? "出料位置" : "输出流量")]?.value === "" ? "" : null),
              desValue: found?.[param.p_engName === "Ns" ? "进料位置" : (param.p_engName === "No" ? "出料位置" : "输出流量")]?.desValue ?? (found?.[param.p_engName === "Ns" ? "进料位置" : (param.p_engName === "No" ? "出料位置" : "输出流量")]?.desValue === "" ? "" : null),
            };
          });
          initialValues[paramName] = {
            show: param.p_show,
            engName: param.p_engName,
            p_children: newChildren.map((child: any) => ({
              流股: {
                value: child.streamName ?? "",
                desValue:child.streamName ?? "",
                show: true,
                engName: "streamName",
                readonly: true,
              },
              [param.p_engName === "Ns" ? "进料位置" : (param.p_engName === "No" ? "出料位置" : "输出流量")]: {
                // value: child.value !== null ? child.value : (param.p_value ?? null),
                value: child.value !== null ? child.value : ((selectNode && test_Rectisol.inputs.elements.find(item=>item.name===selectNode)?.params[param.p_engName]?.[(test_Rectisol.inputs.elements.find(item=>item.name===selectNode)?.[param.p_engName === "Ns"?"inputStreams":"outputStreams"]).findIndex(item=>item.name===(child.streamName??""))]) ?? (param.p_children.find(item=>item.p_engName==="进料位置"||item.p_engName==="出料位置"||item.p_engName==="输出流量").p_value ?? null)),
                desValue : child.desValue  !== null ? child.desValue  : ((selectNode && test_Rectisol.inputs.elements.find(item=>item.name===selectNode)?.params[param.p_engName]?.[(test_Rectisol.inputs.elements.find(item=>item.name===selectNode)?.[param.p_engName === "Ns"?"inputStreams":"outputStreams"]).findIndex(item=>item.name===(child.streamName??""))]) ?? (param.p_children.find(item=>item.p_engName==="进料位置"||item.p_engName==="出料位置"||item.p_engName==="输出流量").p_value ?? null)),
                show: true,
                engName: param.p_engName === "Ns" ? "进料位置" : (param.p_engName === "No" ? "出料位置" : "输出流量"),
              },
            })),
          };
        } 
        else 
        {
          initialValues[paramName] = 
          {
            show: param.p_show,
            engName: param.p_engName,
            p_children: [],
          };
        }
      }
      else if(param.p_engName === "cold_out_T" || param.p_engName === "hot_out_T")
      {
        if (nodeKey && linkDataArray) 
        {
          const direction = param.p_engName === "cold_out_T" ? "cold" : "hot";
          const links = getRelatedLinks2(nodeKey, direction,linkDataArray);
          const savedChildren = saved.p_children || []; // 已保存的位置值（按链接 key 索引）
          const newChildren = links.map((link) => {
            // 查找已保存的值
            return {
              linkKey: link.key,
              streamName: link.text || link.linkName || "",
              value:
                savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.["出口温度"]?.value ? 
                savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.["出口温度"]?.value : 
                (savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.["出口温度"]?.value==="" ? "" : null),
              desValue:
                savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.["出口温度"]?.desValue ? 
                savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.["出口温度"]?.desValue : 
                (savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.["出口温度"]?.desValue==="" ? "" : null),
              unit:savedChildren.find(item=>item?.["流股"]?.value === link.text)?.["出口温度"]?.unit ?? unitMap[param.p_children.find(item=>item.p_engName==="出口温度")?.p_type][0]
            };
          });
          initialValues[paramName] = {
            show: param.p_show,
            engName: param.p_engName,
            p_children: newChildren.map((child) => ({
              流股: {
                value: child.streamName??"",
                desValue: child.streamName??"",
                show: true,
                engName: "streamName",
                readonly: true,
              },
              出口温度: {
                value: child.value?child.value:(child.value==="" ?"":(param.p_children.find(i=>i.p_engName==="出口温度").p_value??null)),
                desValue: child.desValue?child.desValue:(child.desValue==="" ?"":(param.p_children.find(i=>i.p_engName==="出口温度").p_value??null)),
                show: true,
                engName: "出口温度",
                unit:child.unit
              },
            })),
          };
        } 
        else 
        {
          // 降级处理
          initialValues[paramName] = {
            show: param.p_show,
            engName: param.p_engName,
            p_children: [],
          };
        }
      }
      else if(param.p_engName === "cold_out_P" || param.p_engName === "hot_out_P")
      {
        if (nodeKey && linkDataArray) 
        {
          const direction = param.p_engName === "cold_out_P" ? "cold" : "hot";
          const links = getRelatedLinks2(nodeKey, direction,linkDataArray);
          const savedChildren = saved.p_children || []; // 已保存的位置值（按链接 key 索引）
          const newChildren = links.map((link) => {
            // 查找已保存的值
            return {
              linkKey: link.key,
              streamName: link.text || link.linkName || "",
              value:
                savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.["出口压力"]?.value ? 
                savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.["出口压力"]?.value : 
                (savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.["出口压力"]?.value==="" ? "" : null),
              desValue:
                savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.["出口压力"]?.desValue ? 
                savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.["出口压力"]?.desValue : 
                (savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.["出口压力"]?.desValue==="" ? "" : null),
              unit:savedChildren.find(item=>item?.["流股"]?.value === link.text)?.["出口压力"]?.unit ?? unitMap[param.p_children.find(item=>item.p_engName==="出口压力")?.p_type][0]
            };
          });
          initialValues[paramName] = {
            show: param.p_show,
            engName: param.p_engName,
            p_children: newChildren.map((child) => ({
              流股: {
                value: child.streamName??"",
                desValue: child.streamName??"",
                show: true,
                engName: "streamName",
                readonly: true,
              },
              出口压力: {
                value: child.value?child.value:(child.value==="" ?"":(param.p_children.find(i=>i.p_engName==="出口压力").p_value??null)),
                desValue: child.desValue?child.desValue:(child.desValue==="" ?"":(param.p_children.find(i=>i.p_engName==="出口压力").p_value??null)),
                show: true,
                engName: "出口压力",
                unit:child.unit
              },
            })),
          };
        } 
        else 
        {
          // 降级处理
          initialValues[paramName] = {
            show: param.p_show,
            engName: param.p_engName,
            p_children: [],
          };
        }
      }
      else if(param.p_engName === "stream_type")
      {
        let defaultChildren = [{}];
        for(let i=0;i<param.p_children.length;i++)
        {
          let defaultChild = 
          {
            "value":param.p_children[i].p_value,
            "desValue":param.p_children[i].p_value,
            "show":param.p_children[i].p_show,
            "engName":param.p_children[i].p_engName,
          };
          defaultChildren[0][param.p_children[i].p_name] = defaultChild;
        }

        initialValues[paramName] = {
          show:
            saved.show !== undefined
              ? saved.show
              : param.p_show !== undefined
                ? param.p_show
                : false,
          engName:
            saved.engName !== undefined
              ? saved.engName
              : param.p_engName !== undefined
                ? param.p_engName
                : null,
          p_children: saved.p_children?(saved.p_children.length===1?saved.p_children:defaultChildren):defaultChildren,
        };
      }
      else 
      {
        initialValues[paramName] = 
        {
          show: saved.show !== undefined ? saved.show : param.p_show ?? false,
          engName: saved.engName ?? param.p_engName ?? null,
          p_children: saved.p_children || [],
        };
      }
    } 
    else if (param.enum && Array.isArray(param.enum) && param.enum.length > 0) 
    {
      initialValues[paramName] = {
        value: saved.value != null && saved.value !== "" ? saved.value : param.enum[0]?.value,
        desValue:saved.value != null && saved.value !== "" ? saved.value : param.enum[0]?.value,
        show: saved.show !== undefined ? saved.show : param.p_show ?? false,
        engName: saved.engName ?? param.p_engName ?? null,
      };
    } 
    else if (param.p_unit && Array.isArray(param.p_unit) && param.p_unit.length > 0) 
    {
      initialValues[paramName] = {
        // value: saved.value !== undefined ? saved.value : (param.p_value ?? null),
        value: saved.value !== undefined ? saved.value : ( (selectNode && test_Rectisol.inputs.elements.find(item=>item.name===selectNode)?.params[param.p_engName]) ?? (param.p_value ?? null)),
        desValue: saved.desValue !== undefined ? saved.desValue : ( (selectNode && test_Rectisol.inputs.elements.find(item=>item.name===selectNode)?.params[param.p_engName]) ?? (param.p_value ?? null)),
        unit: saved.unit != null && saved.unit !== "" ? saved.unit : param.p_unit[0],
        show: saved.show !== undefined ? saved.show : param.p_show ?? false,
        engName: saved.engName ?? param.p_engName ?? null,
        unitField: saved.unitField ?? param.p_unitField ?? null,
      };
    } 
    else 
    {
      initialValues[paramName] = {
        // value: saved.value !== undefined ? saved.value : (param.p_value ?? null),
        value: saved.value !== undefined ? saved.value : ( (selectNode && test_Rectisol.inputs.elements.find(item=>item.name===selectNode)?.params[param.p_engName]) ?? (param.p_value ?? null)),
        desValue: saved.desValue !== undefined ? saved.desValue : ( (selectNode && test_Rectisol.inputs.elements.find(item=>item.name===selectNode)?.params[param.p_engName]) ?? (param.p_value ?? null)),
        show: saved.show !== undefined ? saved.show : false,
        engName: saved.engName ?? param.p_engName ?? null,
      };
    }
  });

  //特殊处理
  if(initialValues["流股属性"] && initialValues["冷流股出口温度"] && initialValues["热流股出口温度"])
  {
    if(initialValues["流股属性"].value==="冷流股")
    {
      initialValues["冷流股出口温度"].show = true;
      initialValues["热流股出口温度"].show = false;
    }
    else if(initialValues["流股属性"].value==="热流股")
    {
      initialValues["冷流股出口温度"].show = false;
      initialValues["热流股出口温度"].show = true;
    }
  }
  if(initialValues["流股属性"] && initialValues["冷流股出口压力"] && initialValues["热流股出口压力"])
  {
    if(initialValues["流股属性"].value==="冷流股")
    {
      initialValues["冷流股出口压力"].show = true;
      initialValues["热流股出口压力"].show = false;
    }
    else if(initialValues["流股属性"].value==="热流股")
    {
      initialValues["冷流股出口压力"].show = false;
      initialValues["热流股出口压力"].show = true;
    }
  }
  if(initialValues["内部类型"] && initialValues["塔盘类型"] && initialValues["填料类型"])
  {
    if(initialValues["内部类型"].value==="塔板")
    {
      initialValues["塔盘类型"].show = true;
      initialValues["填料类型"].show = false;
    }
    else if(initialValues["内部类型"].value==="填料")
    {
      initialValues["塔盘类型"].show = false;
      initialValues["填料类型"].show = true;
    }
    else if(initialValues["内部类型"].value==="混合")
    {
      initialValues["塔盘类型"].show = true;
      initialValues["填料类型"].show = true;
    }
  }
  if(modal2Data["计算模式"] && initialValues["温度"] && initialValues["汽相分率"])
  {
    if(modal2Data["计算模式"].value==="TP")
    {
      initialValues["温度"].show = true;
      initialValues["汽相分率"].show = false;
    }
    else if(modal2Data["计算模式"].value==="VP"||modal2Data["计算模式"].value==="HP")
    {
      initialValues["温度"].show = false;
      initialValues["汽相分率"].show = true;
    }
  }

  return initialValues;
};

const Component = (props: ComponentProps) => {
  const {
    dataSource,
    settings = { readonly: false },
    setDiagrams,
    overview = true,
    globalData,
    onScaleChange,
    diagramsRef,
  } = props;
  const $ = go.GraphObject.make;
  const [curTube, setCurTube] = useState<any>(null);
  const diagramInstance = useRef<go.Diagram | null>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalParams, setModalParams] = useState(null);
  const [modal2Visible, setModal2Visible] = useState(false);
  const [modal2Data, setModal2Data] = useState(null);
  const [materialsData, setMaterialsData] = useState(null);
  const [localFormData, setLocalFormData] = useState<Record<string, any>>({});
  const [localParamValues, setLocalParamValues] = useState<Record<string, any>>({});
  const [localMaterialsData, setLocalMaterialsData] = useState<Record<string, any>>({});
  const [pageHeight, setPageHeight] = useState(() => {
    if (typeof window !== "undefined") {
      return window.innerHeight - 85;
    }
    return 500;
  });
  const [selectElement, setSelectElement] = useState<string>("");
  const [messageApi, contextHolder] = message.useMessage();
  const overviewContainerRef = useRef(null);
  const overviewInstanceRef = useRef<any>(null);
  const { state, actions } = useAppContext();
  const [isLinkSelected, setIsLinkSelected] = useState(false);
  const [wrapOffset, setWrapOffset] = useState({ x: 0, y: 0 });
  const [designVisible, setDesignVisible] = useState(false);
  const [fastVisible, setFastVisible] = useState(false);
  const [saveAbled, setSaveAbled] = useState(false);
  const [streamsBasicParams, setStreamsBasicParams] = useState([
    {
      p_name: "类型",
      p_engName: "type",
      p_show: true,
      enum: [
        { label: "进料", value: "进料" },
        { label: "出料", value: "出料" },
        { label: "内部", value: "内部" },
      ],
    },
    {
      p_name: "物性计算方法",
      p_engName: "physical_method",
      p_show: true,
      enum: [
        { label: "NRTL-RK", value: "NRTL" },
        { label: "SRK", value: "SRK" },
      ],
    },
    {
      p_name: "相态",
      p_engName: "phase",
      p_show: true,
      enum: [
        { label: "L-液相", value: "L" },
        { label: "V-汽相", value: "V" },
        { label: "VL-汽液两相", value: "VL" },
      ],
    },
    {
      p_name: "计算模式",
      p_engName: "mode",
      p_show: true,
      enum: [
        { label: "TP-温压闪蒸", value: "TP" },
        { label: "VP-汽化率压力闪蒸", value: "VP" },
        { label: "HP-压焓闪蒸", value: "HP" },
      ],
    },
    {
      p_name: "流股属性",
      p_engName: "streamAttribute",
      p_show: true,
      enum: [
        { label: "无", value: "无" },
        { label: "冷流股", value: "冷流股" },
        { label: "热流股", value: "热流股" },
      ],
    },
    { p_name: "流量", p_engName: "f", p_show: true, p_unitField: "", p_unit: ["kg/h"],p_value:"16500.19495"},
    { p_name: "温度", p_engName: "t", p_show: true, p_unitField: "", p_type:"T",p_unit: unitMap["T"],p_value:"120" },
    { p_name: "压力", p_engName: "p", p_show: true, p_unitField: "", p_type:"P",p_unit: unitMap["P"],p_value:"50.49" },
  ]);

  useEffect(() => {
    console.log("state:", state);

    const handleResize = () => {
      setPageHeight(window.innerHeight - 85);
    };

    window.addEventListener("resize", handleResize);

    // 清理函数，避免内存泄漏
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    let nodeName = null;
    //元件信息
    if (modalVisible && modal2Data && typeof modal2Data === "object") 
    {
      // 深拷贝一份，避免直接引用原对象
      setLocalFormData(JSON.parse(JSON.stringify(modal2Data)));
      if(modal2Data["元件名称"])
      {
        nodeName = modal2Data["元件名称"].value;
      }
    }

    //流股组分摩尔分率
    if (modalVisible && materialsData && typeof materialsData === "object") {
      // 深拷贝一份，避免直接引用原对象
      setLocalMaterialsData(JSON.parse(JSON.stringify(materialsData)));
    }

    //元件参数
    if (modalVisible && modalParams && Array.isArray(modalParams)) {
      // 获取当前选中图元已保存的参数值
      let savedValues = {};
      if (diagramInstance.current) {
        const selectedPart = diagramInstance.current.selection.first();
        if (selectedPart && selectedPart.data && selectedPart.data.ParamValues) {
          savedValues = selectedPart.data.ParamValues;
        }
      }
      const initialValues = {};
      modalParams.forEach((param) => 
      {
        const paramName = param?.p_name;
        const saved = savedValues[paramName] || {}; // 取已保存的值，若无则为空对象

        if (param.p_children && Array.isArray(param.p_children) && param.p_children.length > 0) {
          // 带子项的参数：主项存储容器，子项数据放在 p_children 数组中
          // 特殊处理 Ns 和 No
          if (param.p_engName === "Ns" || param.p_engName === "No" || param.p_engName === "output_f") 
          {
            const selectedNode = diagramInstance.current?.selection.first();
            const nodeKey = selectedNode?.data?.key;
            if (nodeKey) {
              const direction = param.p_engName === "Ns" ? "in" : "out";
              const links = getRelatedLinks(nodeKey, direction);
              const savedChildren = saved.p_children || []; // 已保存的位置值（按链接 key 索引）
              const newChildren = links.map((link) => {
                // 查找已保存的值
                return {
                  linkKey: link.key,
                  streamName: link.text || link.linkName || "",
                  value:
                    savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[param.p_engName === "Ns" ? "进料位置" : (param.p_engName === "No" ? "出料位置" : "输出流量")]?.value ? 
                    savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[param.p_engName === "Ns" ? "进料位置" : (param.p_engName === "No" ? "出料位置" : "输出流量")]?.value : 
                    (savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[param.p_engName === "Ns" ? "进料位置" : (param.p_engName === "No" ? "出料位置" : "输出流量")]?.value==="" ? "" : null),
                  desValue:
                    savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[param.p_engName === "Ns" ? "进料位置" : (param.p_engName === "No" ? "出料位置" : "输出流量")]?.desValue ? 
                    savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[param.p_engName === "Ns" ? "进料位置" : (param.p_engName === "No" ? "出料位置" : "输出流量")]?.desValue : 
                    (savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.[param.p_engName === "Ns" ? "进料位置" : (param.p_engName === "No" ? "出料位置" : "输出流量")]?.desValue==="" ? "" : null),
                };
              });
              initialValues[paramName] = {
                show: param.p_show,
                engName: param.p_engName,
                p_children: newChildren.map((child) => ({
                  流股: {
                    value: child.streamName??"",
                    desValue: child.streamName??"",
                    show: true,
                    engName: "streamName",
                    readonly: true,
                  },
                  [param.p_engName === "Ns" ? "进料位置" : (param.p_engName === "No" ? "出料位置" : "输出流量")]: {
                    //value: child.value?child.value:(child.value==="" ?"":(param.p_value??null)),
                    value: child.value?child.value:(child.value==="" ?"": ( (nodeName && test_Rectisol.inputs.elements.find(item=>item.name===nodeName)?.params[param.p_engName]?.[(test_Rectisol.inputs.elements.find(item=>item.name===nodeName)?.[param.p_engName === "Ns"?"inputStreams":"outputStreams"]).findIndex(item=>item.name===(child.streamName??""))]) ?? (param.p_children.find(item=>item.p_engName==="进料位置"||item.p_engName==="出料位置"||item.p_engName==="输出流量").p_value??null))),
                    desValue: child.desValue?child.desValue:(child.desValue==="" ?"": ( (nodeName && test_Rectisol.inputs.elements.find(item=>item.name===nodeName)?.params[param.p_engName]?.[(test_Rectisol.inputs.elements.find(item=>item.name===nodeName)?.[param.p_engName === "Ns"?"inputStreams":"outputStreams"]).findIndex(item=>item.name===(child.streamName??""))]) ?? (param.p_children.find(item=>item.p_engName==="进料位置"||item.p_engName==="出料位置"||item.p_engName==="输出流量").p_value??null))),
                    show: true,
                    engName: param.p_engName === "Ns" ? "进料位置" : (param.p_engName === "No" ? "出料位置" : "输出流量"),
                  },
                })),
              };
            } 
            else 
            {
              // 降级处理
              initialValues[paramName] = {
                show: param.p_show,
                engName: param.p_engName,
                p_children: [],
              };
            }
          }
          else if(param.p_engName === "cold_out_T" || param.p_engName === "hot_out_T")
          {
            const selectedNode = diagramInstance.current?.selection.first();
            const nodeKey = selectedNode?.data?.key;
            if (nodeKey) 
            {
              const direction = param.p_engName === "cold_out_T" ? "cold" : "hot";
              const links = getRelatedLinks2(nodeKey, direction);
              const savedChildren = saved.p_children || []; // 已保存的位置值（按链接 key 索引）
              const newChildren = links.map((link) => {
                // 查找已保存的值
                return {
                  linkKey: link.key,
                  streamName: link.text || link.linkName || "",
                  value:
                    savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.["出口温度"]?.value ? 
                    savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.["出口温度"]?.value : 
                    (savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.["出口温度"]?.value==="" ? "" : null),
                  desValue:
                    savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.["出口温度"]?.desValue ? 
                    savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.["出口温度"]?.desValue : 
                    (savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.["出口温度"]?.desValue==="" ? "" : null),
                  unit:savedChildren.find(item=>item?.["流股"]?.value === link.text)?.["出口温度"]?.unit ?? unitMap[param.p_children.find(item=>item.p_engName==="出口温度")?.p_type][0]
                };
              });
              initialValues[paramName] = {
                show: param.p_show,
                engName: param.p_engName,
                p_children: newChildren.map((child) => ({
                  流股: {
                    value: child.streamName??"",
                    desValue: child.streamName??"",
                    show: true,
                    engName: "streamName",
                    readonly: true,
                  },
                  出口温度: {
                    value: child.value?child.value:(child.value==="" ?"":(param.p_children.find(i=>i.p_engName==="出口温度").p_value??null)),
                    desValue: child.desValue?child.desValue:(child.desValue==="" ?"":(param.p_children.find(i=>i.p_engName==="出口温度").p_value??null)),
                    show: true,
                    engName: "出口温度",
                    unit:child.unit
                  },
                })),
              };
            } 
            else 
            {
              // 降级处理
              initialValues[paramName] = {
                show: param.p_show,
                engName: param.p_engName,
                p_children: [],
              };
            }
          }
          else if(param.p_engName === "cold_out_P" || param.p_engName === "hot_out_P")
          {
            const selectedNode = diagramInstance.current?.selection.first();
            const nodeKey = selectedNode?.data?.key;
            if (nodeKey) 
            {
              const direction = param.p_engName === "cold_out_P" ? "cold" : "hot";
              const links = getRelatedLinks2(nodeKey, direction);
              const savedChildren = saved.p_children || []; // 已保存的位置值（按链接 key 索引）
              const newChildren = links.map((link) => {
                // 查找已保存的值
                return {
                  linkKey: link.key,
                  streamName: link.text || link.linkName || "",
                  value:
                    savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.["出口压力"]?.value ? 
                    savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.["出口压力"]?.value : 
                    (savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.["出口压力"]?.value==="" ? "" : null),
                  desValue:
                    savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.["出口压力"]?.desValue ? 
                    savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.["出口压力"]?.desValue : 
                    (savedChildren.filter((item) => item?.["流股"]?.value === link.text)?.[0]?.["出口压力"]?.desValue==="" ? "" : null),
                  unit:savedChildren.find(item=>item?.["流股"]?.value === link.text)?.["出口压力"]?.unit ?? unitMap[param.p_children.find(item=>item.p_engName==="出口压力")?.p_type][0]
                };
              });
              initialValues[paramName] = {
                show: param.p_show,
                engName: param.p_engName,
                p_children: newChildren.map((child) => ({
                  流股: {
                    value: child.streamName??"",
                    desValue: child.streamName??"",
                    show: true,
                    engName: "streamName",
                    readonly: true,
                  },
                  出口压力: {
                    value: child.value?child.value:(child.value==="" ?"":(param.p_children.find(i=>i.p_engName==="出口压力").p_value??null)),
                    desValue: child.desValue?child.desValue:(child.desValue==="" ?"":(param.p_children.find(i=>i.p_engName==="出口压力").p_value??null)),
                    show: true,
                    engName: "出口压力",
                    unit:child.unit
                  },
                })),
              };
            } 
            else 
            {
              // 降级处理
              initialValues[paramName] = {
                show: param.p_show,
                engName: param.p_engName,
                p_children: [],
              };
            }
          }
          else if(param.p_engName === "stream_type")
          {
            let defaultChildren = [{}];
            for(let i=0;i<param.p_children.length;i++)
            {
              let defaultChild = 
              {
                "value":param.p_children[i].p_value,
                "desValue":param.p_children[i].p_value,
                "show":param.p_children[i].p_show,
                "engName":param.p_children[i].p_engName,
              };
              defaultChildren[0][param.p_children[i].p_name] = defaultChild;
            }

            initialValues[paramName] = {
              show:
                saved.show !== undefined
                  ? saved.show
                  : param.p_show !== undefined
                    ? param.p_show
                    : false,
              engName:
                saved.engName !== undefined
                  ? saved.engName
                  : param.p_engName !== undefined
                    ? param.p_engName
                    : null,
              p_children: saved.p_children?(saved.p_children.length===1?saved.p_children:defaultChildren):defaultChildren,
            };
          }
          else 
          {
            initialValues[paramName] = {
              show:
                saved.show !== undefined
                  ? saved.show
                  : param.p_show !== undefined
                    ? param.p_show
                    : false,
              engName:
                saved.engName !== undefined
                  ? saved.engName
                  : param.p_engName !== undefined
                    ? param.p_engName
                    : null,
              p_children: saved.p_children || [], // 数组，每个元素是子项的数据对象
            };
          }
        } 
        else if (param.enum && Array.isArray(param.enum) && param.enum.length > 0) 
        {
          // 有枚举字段：选择器，初始值优先取已保存的 value，否则取第一个选项
          initialValues[paramName] = 
          {
            value:
              saved.value !== undefined && saved.value !== null && saved.value !== ""
                ? saved.value
                : param.enum[0]?.value,
            desValue:
              saved.value !== undefined && saved.value !== null && saved.value !== ""
                ? saved.value
                : param.enum[0]?.value,
            show:
              saved.show !== undefined
                ? saved.show
                : param.p_show !== undefined
                  ? param.p_show
                  : false,
            engName:
              saved.engName !== undefined
                ? saved.engName
                : param.p_engName !== undefined
                  ? param.p_engName
                  : null,
          };
        } 
        else if (param.p_unit && Array.isArray(param.p_unit) && param.p_unit.length > 0) 
        {
          // 有单位字段：输入框 + 单位选择器，初始值优先取已保存的 value/unit，否则取默认
          initialValues[paramName] = {
            // value: saved.value !== undefined ? saved.value : (param.p_value??null),
            value: saved.value !== undefined ? saved.value : ( (nodeName && test_Rectisol.inputs.elements.find(item=>item.name===nodeName)?.params[param.p_engName]) ?? (param.p_value ?? null)),
            desValue:saved.desValue !== undefined ? saved.desValue : ( (nodeName && test_Rectisol.inputs.elements.find(item=>item.name===nodeName)?.params[param.p_engName]) ?? (param.p_value ?? null)),
            unit:
              saved.unit !== undefined && saved.unit !== null && saved.unit !== ""
                ? saved.unit
                : param.p_unit[0],
            show:
              saved.show !== undefined
                ? saved.show
                : param.p_show !== undefined
                  ? param.p_show
                  : false,
            engName:
              saved.engName !== undefined
                ? saved.engName
                : param.p_engName !== undefined
                  ? param.p_engName
                  : null,
            unitField:
              saved.unitField !== undefined
                ? saved.unitField
                : param.p_unitField !== undefined
                  ? param.p_unitField
                  : null,
          };
        } 
        else 
          {
          // 仅输入框
          initialValues[paramName] = {
            // value: saved.value !== undefined ? saved.value : (param.p_value??null),
            value: saved.value !== undefined ? saved.value : ( (nodeName && test_Rectisol.inputs.elements.find(item=>item.name===nodeName)?.params[param.p_engName]) ?? (param.p_value ?? null)),
            desValue:saved.desValue !== undefined ? saved.desValue : ( (nodeName && test_Rectisol.inputs.elements.find(item=>item.name===nodeName)?.params[param.p_engName]) ?? (param.p_value ?? null)),
            show: saved.show !== undefined ? saved.show : false,
            engName:
              saved.engName !== undefined
                ? saved.engName
                : param.p_engName !== undefined
                  ? param.p_engName
                  : null,
          };
        }
      });
      
      //特殊处理
      if(initialValues["流股属性"] && initialValues["冷流股出口温度"] && initialValues["热流股出口温度"])
      {
        if(initialValues["流股属性"].value==="冷流股")
        {
          initialValues["冷流股出口温度"].show = true;
          initialValues["热流股出口温度"].show = false;
        }
        else if(initialValues["流股属性"].value==="热流股")
        {
          initialValues["冷流股出口温度"].show = false;
          initialValues["热流股出口温度"].show = true;
        }
      }
      if(initialValues["流股属性"] && initialValues["冷流股出口压力"] && initialValues["热流股出口压力"])
      {
        if(initialValues["流股属性"].value==="冷流股")
        {
          initialValues["冷流股出口压力"].show = true;
          initialValues["热流股出口压力"].show = false;
        }
        else if(initialValues["流股属性"].value==="热流股")
        {
          initialValues["冷流股出口压力"].show = false;
          initialValues["热流股出口压力"].show = true;
        }
      }
      if(initialValues["内部类型"] && initialValues["塔盘类型"] && initialValues["填料类型"])
      {
        if(initialValues["内部类型"].value==="塔板")
        {
          initialValues["塔盘类型"].show = true;
          initialValues["填料类型"].show = false;
        }
        else if(initialValues["内部类型"].value==="填料")
        {
          initialValues["塔盘类型"].show = false;
          initialValues["填料类型"].show = true;
        }
        else if(initialValues["内部类型"].value==="混合")
        {
          initialValues["塔盘类型"].show = true;
          initialValues["填料类型"].show = true;
        }
      }
      if(modal2Data["计算模式"] && initialValues["温度"] && initialValues["汽相分率"])
      {
        if(modal2Data["计算模式"].value==="TP")
        {
          initialValues["温度"].show = true;
          initialValues["汽相分率"].show = false;
        }
        else if(modal2Data["计算模式"].value==="VP"||modal2Data["计算模式"].value==="HP")
        {
          initialValues["温度"].show = false;
          initialValues["汽相分率"].show = true;
        }
      }

      setLocalParamValues(initialValues);
      console.log("initialValues:",initialValues);
    }
  }, [modalVisible, modalParams, modal2Data, materialsData]);

  // 创建一个稳定的引用函数，用于在diagram初始化时设置到父组件和本地引用
  const onDiagramInitialized = useCallback(
    (diagram: go.Diagram) => {
      if (diagram) {
        // 更新本地引用，供组件内部使用
        diagramInstance.current = diagram;
        // diagram.isReadOnly = settings.readonly;
        // 直接设置diagram实例到父组件
        setDiagrams(diagram);

        // 通知初始缩放比例
        if (onScaleChange) {
          onScaleChange(Math.round(diagram.scale * 100));
        }

        // 等待初始布局完成
        diagram.addDiagramListener("InitialLayoutCompleted", () => {
          if (overviewContainerRef.current && !overviewInstanceRef.current) {
            const overview = loadOverview(diagram, overviewContainerRef.current);
            overviewInstanceRef.current = overview;
            overview.requestUpdate();
          }
        });

        console.log("Diagram instance successfully initialized and set to parent component");
      }
    },
    [setDiagrams],
  );

  // 添加清理 useEffect
  useEffect(() => {
    return () => {
      if (overviewInstanceRef.current) {
        // 解除观察，释放资源
        overviewInstanceRef.current.observed = null;
      }
    };
  }, []);

  // 监听图表缩放变化（滚轮、缩放按钮等）
  useEffect(() => {
    const diagram = diagramInstance.current;
    if (!diagram || !onScaleChange) return;

    const handler = () => {
      onScaleChange(Math.round(diagram.scale * 100));
    };

    diagram.addDiagramListener("ViewportBoundsChanged", handler);

    return () => {
      diagram.removeDiagramListener("ViewportBoundsChanged", handler);
    };
  }, [onScaleChange]);

  // 更新图表只读状态的函数
  const updateDiagramReadOnlyState = (diagram: any, isReadOnly: boolean) => {
    if (diagram) {
      diagram.isReadOnly = isReadOnly;
    }
  };

  // 监听settings.readonly属性变化
  useEffect(() => {
    if (diagramInstance.current) {
      updateDiagramReadOnlyState(diagramInstance.current, settings.readonly);
      console.log(`图表已切换到${settings.readonly ? "只读" : "编辑"}模式`);
    }
  }, [settings.readonly]);

  // // 当dataSource变化时，确保diagram模型也同步更新
  // useEffect(() => {
  //   // 这里不需要额外的更新逻辑，因为ReactDiagram组件会自动处理nodeDataArray和linkDataArray的变化
  //   // 但我们可以添加一些调试日志来监控数据更新
  //   console.log("DataSource updated, diagram data should sync automatically");
  // }, [dataSource]);

  const nodeSelectionAdornmentTemplate = new go.Adornment("Auto").add(
    new go.Shape({ fill: null, stroke: "deepskyblue", strokeWidth: 1.5, strokeDashArray: [4, 2] }),
    new go.Placeholder(),
  );

  const nodeRotateAdornmentTemplate = new go.Adornment({
    locationSpot: go.Spot.Center,
    locationObjectName: "ELLIPSE",
  }).add(
    new go.Shape("Ellipse", {
      name: "ELLIPSE",
      cursor: "pointer",
      desiredSize: new go.Size(7, 7),
      fill: "lightblue",
      stroke: "deepskyblue",
    }),
    new go.Shape({
      geometryString: "M-50 3.5 L0 3.5",
      isGeometryPositioned: true,
      stroke: "deepskyblue",
      strokeWidth: 1.5,
      strokeDashArray: [4, 2],
    }),
  );

  const makePort = (name: any, spot: any, output: any, input: any) => {
    // console.log(spot);
    return $(go.Shape, "Circle", {
      fill: null,
      stroke: null, // this is changed to "white" in the showPorts function
      //连接点尺寸
      desiredSize: new go.Size(5, 5),
      alignment: spot,
      alignmentFocus: spot, // align the port on the main Shape
      portId: name, // declare this object to be a "port"
      fromSpot: spot,
      toSpot: spot, // declare where links may connect at this port
      fromLinkable: output,
      toLinkable: input, // declare whether the user may draw links to/from here
      fromLinkableSelfNode: true,
      toLinkableSelfNode: true,
      cursor: "pointer", // show a different cursor to indicate potential link point
    });
  };

  const showPorts = (node: any, show: any) => {
    let diagram = node.diagram;
    if (!diagram || diagram.isReadOnly) return;
    // 移除对diagram.allowLink的检查，因为我们已经在图表初始化时设置了这个属性
    node.ports.each((port: any) => {
      port.stroke = show ? "red" : null;
      port.fill = show ? "red" : null;
    });
  };

  // myContextMenu将在setupTemplates函数内部定义

  // 设置图表模板
  const setupTemplates = (diagram: any) => {
    // 设置模型属性
    diagram.model = $(go.GraphLinksModel, {
      linkFromPortIdProperty: "fromPort",
      linkToPortIdProperty: "toPort",
      linkKeyProperty: "key",
    });

    // 在setupTemplates内部定义右键菜单，确保能正确访问diagram实例
    const myContextMenu = $(go.HTMLInfo, {
      show: () => {
        if (menuRef.current) {
          // 使用viewPoint获取视图坐标，确保菜单位置与图表视图匹配
          const mousePt = diagram.lastInput.viewPoint;
          const selectedPart = diagram.selection.first();
          setIsLinkSelected(selectedPart instanceof go.Link);

          // 设置菜单样式，确保定位正确
          const menu = menuRef.current;
          menu.style.position = "absolute";
          menu.style.left = mousePt.x + "px";
          menu.style.top = mousePt.y + "px";
          menu.style.zIndex = "1000";
          menu.style.display = "block";

          // 确保菜单不超出视口范围
          const rect = menu.getBoundingClientRect();
          if (rect.right > window.innerWidth) {
            menu.style.left = mousePt.x - rect.width + "px";
          }
          if (rect.bottom > window.innerHeight) {
            menu.style.top = mousePt.y - rect.height + "px";
          }
        }
      },
      hide: () => {
        if (menuRef.current) {
          menuRef.current.style.display = "none";
        }
      },
    });

    const tool = new LinkLabelOnPathDraggingTool();
    diagram.toolManager.mouseMoveTools.insertAt(0, tool);

    // 设置group模板
    diagram.groupTemplate = $(
      go.Group,
      "Vertical",
      {
        selectionObjectName: "PANEL", // selection handle goes around shape, not label
        ungroupable: true, // enable Ctrl-Shift-G to ungroup a selected Group
      },
      $(
        go.TextBlock,
        {
          //alignment: go.Spot.Right,
          font: "bold 55px sans-serif",
          isMultiline: false, // don't allow newlines in text
          editable: true, // allow in-place editing by user
          stroke: "rgba(255, 119, 0, 1)",
          textEdited: (textBlock, oldText, newText) => {
            const group = textBlock.part;
            if (group && group.data) {
              if (checkNameUnique(newText, "group", group.data.key)) {
                group.diagram.model.setDataProperty(group.data, "keywords", newText);
              } else {
                group.diagram.model.setDataProperty(group.data, "keywords", oldText);
                messageApi.open({
                  type: "error",
                  content: "分组名称重复",
                });
              }
            }
          },
        },
        new go.Binding("text", "keywords").makeTwoWay(),
        new go.Binding("stroke", "titleColor"),
      ),
      $(
        go.Panel,
        "Auto",
        { name: "PANEL" },
        $(
          go.Shape,
          "Rectangle", // the rectangular shape around the members
          {
            fill: "rgba(128,128,128,0.05)",
            stroke: "rgba(0,0,0,1)",
            strokeWidth: 2,
            strokeDashArray: [50, 30],
            // allow all kinds of links from and to this port
            // fromLinkable: true, fromLinkableSelfNode: true, fromLinkableDuplicates: true,
            // toLinkable: true, toLinkableSelfNode: true, toLinkableDuplicates: true
          },
        ),
        $(go.Placeholder, { margin: 10, background: "transparent" }), // represents where the members are
      ),
      // { // this tooltip Adornment is shared by all groups
      // 	toolTip:
      // 		$("ToolTip",
      // 			$(go.TextBlock, { margin: 4 },
      // 				// bind to tooltip, not to Group.data, to allow access to Group properties
      // 				new go.Binding("text", "", groupInfo).ofObject())
      // 		),
      // 	// the same context menu Adornment is shared by all groups
      // 	contextMenu: partContextMenu
      // }
    );

    diagram.nodeTemplate = $(
      go.Node,
      "Spot", // the Shape will go around the TextBlock
      {
        contextMenu: myContextMenu,
        zOrder: 1,
        mouseEnter: (e, obj) => {
          showPorts(obj.part, true);
        },
        mouseLeave: (e, obj) => {
          showPorts(obj.part, false);
        },
        locationSpot: go.Spot.Center,
      },
      new go.Binding("zOrder", "zOrder"),

      {
        resizable: true,
        resizeObjectName: "SHAPE",
        // selectionObjectName: 'SHAPE',
      },
      {
        selectable: true,
        selectionObjectName: "SHAPE",
        selectionAdornmentTemplate: nodeSelectionAdornmentTemplate,
      },
      {
        rotatable: true,
        rotateObjectName: "SHAPE",
        rotateAdornmentTemplate: nodeRotateAdornmentTemplate,
      },

      // {
      //   selectable: true,
      //   selectionObjectName: 'SHAPE',
      //   // selectionAdornmentTemplate: gojs(
      //   //   go.Adornment,
      //   //   'Auto',
      //   //   gojs(go.Shape, {
      //   //     fill: null,
      //   //     stroke: 'rgba(220,110,5,1)',
      //   //     strokeWidth: 2,
      //   //     // strokeDashArray: [1, 2],
      //   //   }),
      //   //   gojs(go.Placeholder)
      //   // ),
      // },

      $(
        go.Picture,
        {
          name: "SHAPE",
        },

        new go.Binding("source", "icon").makeTwoWay(),
        new go.Binding("angle").makeTwoWay(),
        new go.Binding("desiredSize", "size", go.Size.parse).makeTwoWay(go.Size.stringify),

        // new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify),
      ),
      makePort("T1", new go.Spot(1 / 20, 0, 0, 0), true, true),
      makePort("T2", new go.Spot(2 / 20, 0, 0, 0), true, true),
      makePort("T3", new go.Spot(3 / 20, 0, 0, 0), true, true),
      makePort("T4", new go.Spot(4 / 20, 0, 0, 0), true, true),
      makePort("T5", new go.Spot(5 / 20, 0, 0, 0), true, true),
      makePort("T6", new go.Spot(6 / 20, 0, 0, 0), true, true),
      makePort("T7", new go.Spot(7 / 20, 0, 0, 0), true, true),
      makePort("T8", new go.Spot(8 / 20, 0, 0, 0), true, true),
      makePort("T9", new go.Spot(9 / 20, 0, 0, 0), true, true),
      makePort("T10", new go.Spot(10 / 20, 0, 0, 0), true, true),
      makePort("T11", new go.Spot(11 / 20, 0, 0, 0), true, true),
      makePort("T12", new go.Spot(12 / 20, 0, 0, 0), true, true),
      makePort("T13", new go.Spot(13 / 20, 0, 0, 0), true, true),
      makePort("T14", new go.Spot(14 / 20, 0, 0, 0), true, true),
      makePort("T15", new go.Spot(15 / 20, 0, 0, 0), true, true),
      makePort("T16", new go.Spot(16 / 20, 0, 0, 0), true, true),
      makePort("T17", new go.Spot(17 / 20, 0, 0, 0), true, true),
      makePort("T18", new go.Spot(18 / 20, 0, 0, 0), true, true),
      makePort("T19", new go.Spot(19 / 20, 0, 0, 0), true, true),
      makePort("T20", new go.Spot(20 / 20, 0, 0, 0), true, true),

      makePort("B1", new go.Spot(1 / 20, 1, 0, 0), true, true),
      makePort("B2", new go.Spot(2 / 20, 1, 0, 0), true, true),
      makePort("B3", new go.Spot(3 / 20, 1, 0, 0), true, true),
      makePort("B4", new go.Spot(4 / 20, 1, 0, 0), true, true),
      makePort("B5", new go.Spot(5 / 20, 1, 0, 0), true, true),
      makePort("B6", new go.Spot(6 / 20, 1, 0, 0), true, true),
      makePort("B7", new go.Spot(7 / 20, 1, 0, 0), true, true),
      makePort("B8", new go.Spot(8 / 20, 1, 0, 0), true, true),
      makePort("B9", new go.Spot(9 / 20, 1, 0, 0), true, true),
      makePort("B10", new go.Spot(10 / 20, 1, 0, 0), true, true),
      makePort("B11", new go.Spot(11 / 20, 1, 0, 0), true, true),
      makePort("B12", new go.Spot(12 / 20, 1, 0, 0), true, true),
      makePort("B13", new go.Spot(13 / 20, 1, 0, 0), true, true),
      makePort("B14", new go.Spot(14 / 20, 1, 0, 0), true, true),
      makePort("B15", new go.Spot(15 / 20, 1, 0, 0), true, true),
      makePort("B16", new go.Spot(16 / 20, 1, 0, 0), true, true),
      makePort("B17", new go.Spot(17 / 20, 1, 0, 0), true, true),
      makePort("B18", new go.Spot(18 / 20, 1, 0, 0), true, true),
      makePort("B19", new go.Spot(19 / 20, 1, 0, 0), true, true),
      makePort("B20", new go.Spot(20 / 20, 1, 0, 0), true, true),

      makePort("L1", new go.Spot(0, 1 / 20, 0, 0), true, true),
      makePort("L2", new go.Spot(0, 2 / 20, 0, 0), true, true),
      makePort("L3", new go.Spot(0, 3 / 20, 0, 0), true, true),
      makePort("L4", new go.Spot(0, 4 / 20, 0, 0), true, true),
      makePort("L5", new go.Spot(0, 5 / 20, 0, 0), true, true),
      makePort("L6", new go.Spot(0, 6 / 20, 0, 0), true, true),
      makePort("L7", new go.Spot(0, 7 / 20, 0, 0), true, true),
      makePort("L8", new go.Spot(0, 8 / 20, 0, 0), true, true),
      makePort("L9", new go.Spot(0, 9 / 20, 0, 0), true, true),
      makePort("L10", new go.Spot(0, 10 / 20, 0, 0), true, true),
      makePort("L11", new go.Spot(0, 11 / 20, 0, 0), true, true),
      makePort("L12", new go.Spot(0, 12 / 20, 0, 0), true, true),
      makePort("L13", new go.Spot(0, 13 / 20, 0, 0), true, true),
      makePort("L14", new go.Spot(0, 14 / 20, 0, 0), true, true),
      makePort("L15", new go.Spot(0, 15 / 20, 0, 0), true, true),
      makePort("L16", new go.Spot(0, 16 / 20, 0, 0), true, true),
      makePort("L17", new go.Spot(0, 17 / 20, 0, 0), true, true),
      makePort("L18", new go.Spot(0, 18 / 20, 0, 0), true, true),
      makePort("L19", new go.Spot(0, 19 / 20, 0, 0), true, true),
      makePort("L20", new go.Spot(0, 20 / 20, 0, 0), true, true),

      makePort("R1", new go.Spot(1, 1 / 20, 0, 0), true, true),
      makePort("R2", new go.Spot(1, 2 / 20, 0, 0), true, true),
      makePort("R3", new go.Spot(1, 3 / 20, 0, 0), true, true),
      makePort("R4", new go.Spot(1, 4 / 20, 0, 0), true, true),
      makePort("R5", new go.Spot(1, 5 / 20, 0, 0), true, true),
      makePort("R6", new go.Spot(1, 6 / 20, 0, 0), true, true),
      makePort("R7", new go.Spot(1, 7 / 20, 0, 0), true, true),
      makePort("R8", new go.Spot(1, 8 / 20, 0, 0), true, true),
      makePort("R9", new go.Spot(1, 9 / 20, 0, 0), true, true),
      makePort("R10", new go.Spot(1, 10 / 20, 0, 0), true, true),
      makePort("R11", new go.Spot(1, 11 / 20, 0, 0), true, true),
      makePort("R12", new go.Spot(1, 12 / 20, 0, 0), true, true),
      makePort("R13", new go.Spot(1, 13 / 20, 0, 0), true, true),
      makePort("R14", new go.Spot(1, 14 / 20, 0, 0), true, true),
      makePort("R15", new go.Spot(1, 15 / 20, 0, 0), true, true),
      makePort("R16", new go.Spot(1, 16 / 20, 0, 0), true, true),
      makePort("R17", new go.Spot(1, 17 / 20, 0, 0), true, true),
      makePort("R18", new go.Spot(1, 18 / 20, 0, 0), true, true),
      makePort("R19", new go.Spot(1, 19 / 20, 0, 0), true, true),
      makePort("R20", new go.Spot(1, 20 / 20, 0, 0), true, true),
      new go.Binding("location", "loc", go.Point.parse).makeTwoWay(go.Point.stringify),

      $(
        go.Panel,
        "Auto",
        {
          alignment: new go.Spot(0.5, 1.2),
          // isActionable: true,
        },
        new go.Binding("alignment", "point", function (x) {
          return new go.Spot(x[0], x[1]);
        }),

        $(
          go.Shape,
          "RoundedRectangle",
          {
            fill: "red",
            stroke: null,
            parameter1: 3,

            // desiredSize: new go.Size(999, 50),
            // cursor: "move",
            // pickable: true,
            // isActionable: true,
          },
          new go.Binding("fill", "textBackground").makeTwoWay(),
        ),

        $(
          go.TextBlock,
          {
            editable: true,
            //元件下方文字尺寸
            font: "12pt Segoe UI,sans-serif",
            stroke: "#000",
            margin: new go.Margin(5, 10, 2, 10),
            // margin: new go.Margin(5, 6, 3, 6),
            // margin: new go.Margin(10,10,10,10),
            // alignment: new go.Spot(0.5, 1.2),
            // minSize: new go.Size(10, 14),
            // alignment: new go.Spot(0.5, 1.05),
            // margin: new go.Margin(10, 0, 10, 0),
            textEdited: (textBlock, oldText, newText) => {
              const node = textBlock.part;
              if (node && node.data) {
                if (checkNameUnique(newText, "node", node.data.key)) {
                  node.diagram.model.setDataProperty(node.data, "nodeName", newText);
                  node.diagram.model.setDataProperty(node.data, "text", newText);
                } else {
                  node.diagram.model.setDataProperty(node.data, "text", oldText);
                  messageApi.open({
                    type: "error",
                    content: "元件名称重复",
                  });
                }
              }
            },
          },
          new go.Binding("text", "text").makeTwoWay(),
          new go.Binding("stroke", "textColor").makeTwoWay(),
          // new go.Binding("font", "fontSize", function (size) {
          //   return size + "pt Lato, sans-serif";
          // }).makeTwoWay(),
          new go.Binding("font", "fontSize").makeTwoWay(),
          // new go.Binding("alignment", "point", function (x) {
          //   return new go.Spot(x[0], x[1]);
          // }),
          // new go.Binding("background", "textBackground").makeTwoWay(),
        ),
      ),

      // $(
      //   go.Shape,
      //   'RoundedRectangle',
      //   { strokeWidth: 0, fill: 'white' },
      //   // Shape.fill is bound to Node.data.color
      //   new go.Binding('fill', 'color'),
      // ),
      // $(
      //   go.TextBlock,
      //   { margin: 8 }, // some room around the text
      //   // TextBlock.text is bound to Node.data.key
      //   new go.Binding('text', 'key'),
      // ),
    );
    // );

    // setDiagram(diagram);

    diagram.nodeTemplateMap.add(
      "Comment",
      $(
        go.Node,
        "Auto", // the Shape will go around the TextBlock
        { contextMenu: myContextMenu },
        $(
          // go.Shape,
          // "rectangle",
          // {
          //   strokeWidth: 1,
          //   stroke: "rgba(255,255,255,0.3)",
          //   fill: "rgba(255,255,255,0.1)",
          // },
          go.Picture,
          {
            name: "SHAPE",
          },
          new go.Binding("source", "icon").makeTwoWay(),
          new go.Binding("angle").makeTwoWay(),
          new go.Binding("desiredSize", "size", go.Size.parse).makeTwoWay(go.Size.stringify),

          // Shape.fill is bound to Node.data.color
          // new go.Binding("strokeWidth", "borderWidth").makeTwoWay(),
          // new go.Binding("fill", "bgColor").makeTwoWay(),
          // new go.Binding("stroke", "borderColor").makeTwoWay()
        ),

        $(
          go.TextBlock,
          {
            margin: 4,
            font: "16px sans-serif",
            stroke: "#000",
          }, // Specify a margin to add some room around the text
          // TextBlock.text is bound to Node.data.key
          {
            editable: true,
            alignment: new go.Spot(0.5, 0.5),
          },
          new go.Binding("text").makeTwoWay(),
          // new go.Binding('text', 'text'), //显示控件文字
          // new go.Binding("desiredSize", "size", go.Size.parse).makeTwoWay(go.Size.stringify),
          new go.Binding("stroke", "fontColor").makeTwoWay(),
          new go.Binding("font", "textSize", function (size) {
            return size + "px Lato, sans-serif";
          }).makeTwoWay(),
          new go.Binding("alignment", "point", function (x) {
            return new go.Spot(x[0], x[1]);
          }).makeTwoWay(),
        ),
        new go.Binding("location", "loc", go.Point.parse).makeTwoWay(go.Point.stringify),
        // makePort("T", go.Spot.Top, true, true),
        // makePort("L", go.Spot.Left, true, true),
        // makePort("R", go.Spot.Right, true, true),
        // makePort("B", go.Spot.Bottom, true, true)
      ),
    );

    diagram.linkTemplate = $(
      go.Link,
      // defined below
      { contextMenu: myContextMenu },
      {
        routing: go.Link.AvoidsNodes,
        // contextMenu: myContextMenu,
        corner: 0,
        curve: go.Link.JumpGap,
        relinkableFrom: true,
        relinkableTo: true,
        reshapable: true,
        resegmentable: true,

        // mouseEnter: function (e, link) {
        //   link.findObject('HIGHLIGHT').stroke = 'rgba(30,144,255,0.2)';
        // },
        // mouseLeave: function (e, link) {
        //   link.findObject('HIGHLIGHT').stroke = 'transparent';
        // },
      },
      new go.Binding("points").makeTwoWay(),
      // { contextMenu: myContextMenu },
      $(
        go.Shape,
        {
          isPanelMain: true,
          strokeWidth: 15,
          stroke: "transparent", // 默认透明
          name: "BACKGROUND"
        },
        new go.Binding("stroke", "linkBgColor").makeTwoWay(),  //连接线背景色
        new go.Binding("strokeWidth", "strokeWidth", (w) => (w !== undefined ? 12+w*3 : 10)) //连接线背景宽度
      ),
      $(
        go.Shape, // the highlight shape, normally transparent
        { isPanelMain: true, strokeWidth: 15, stroke: "transparent", name: "HIGHLIGHT" },
      ),
      $(
        go.Shape,
        {
          isPanelMain: true,
          stroke: "rgba(0,0,0,1)",
          strokeWidth: 1,
          // strokeDashArray:[0,0] // 虚线
        },
        new go.Binding("stroke", "lineColor").makeTwoWay(),
        new go.Binding("strokeWidth", "strokeWidth").makeTwoWay(),
        new go.Binding("strokeDashArray", "lineType").makeTwoWay(),
      ),

      $(
        go.Shape, // the highlight shape, normally transparent
        { isPanelMain: true, strokeWidth: 15, stroke: "transparent", name: "HIGHLIGHT" },
      ),
      // $(
      //   go.Shape,
      //   { isPanelMain: true, stroke: "#787878", strokeWidth: 12 },
      //   new go.Binding("stroke", "lineColor1").makeTwoWay(),
      //   new go.Binding("strokeWidth", "strokeWidth1").makeTwoWay()
      // ),
      // $(
      //   go.Shape,
      //   { isPanelMain: true, stroke: "#a3a3a3", strokeWidth: 8 },
      //   new go.Binding("stroke", "lineColor2").makeTwoWay(),
      //   new go.Binding("strokeWidth", "strokeWidth2").makeTwoWay()
      // ),
      // $(
      //   go.Shape,
      //   { isPanelMain: true, stroke: "#dbdbdb", strokeWidth: 4, strokeDashArray: [0, 0] },
      //   new go.Binding("stroke", "lineColor3").makeTwoWay(),
      //   new go.Binding("strokeWidth", "strokeWidth3").makeTwoWay(),
      //   new go.Binding("strokeDashArray", "lineType").makeTwoWay()
      // ),

      // $(go.Shape, { isPanelMain: true, stroke: "#715715", strokeWidth: 6 }),
      // $(go.Shape, { isPanelMain: true, stroke: "#D8B06E", strokeWidth: 2 }),
      // $(go.Shape, { isPanelMain: true, stroke: "#E6C37C" }),
      $(
        go.Shape,
        {
          toArrow: "Triangle",
          stroke: "black",
          fill: "blcak",
          //连接线箭头尺寸
          strokeWidth: 1,
        },
        // new go.Binding("fill", "arrowColor"),
        new go.Binding("strokeWidth", "arrowScale").makeTwoWay(),
        new go.Binding("stroke", "lineColor").makeTwoWay(),
        new go.Binding("fill", "lineColor"),
      ),

      $(
        go.Panel,
        "Auto", // the link label, normally not visible
        { visible: true, name: "LABEL", segmentIndex: 2, segmentFraction: 0.5, _isLinkLabel: true },
        new go.Binding("visible", "visible").makeTwoWay(),
        new go.Binding("segmentIndex", "segmentIndex").makeTwoWay(),
        new go.Binding("segmentFraction", "segmentFraction").makeTwoWay(),
        $(
          go.Shape,
          "Rectangle", // the label shape
          { fill: "#f0fdffff", stroke: "#0273b9ff", strokeWidth: 1 },
          new go.Binding("fill", "shapeBG").makeTwoWay(), //连接线文字背景颜色
          new go.Binding("stroke", "shapeBorder").makeTwoWay(), //连接线文字边框颜色
          new go.Binding("strokeWidth", "shapeBorderWidth").makeTwoWay(), //连接线文字边框宽度
        ),
        $(
          go.TextBlock,
          "Stream", // the label
          {
            textAlign: "center",
            //连接线文字尺寸
            // font: "12pt helvetica, arial, sans-serif",
            stroke: "#333333",
            editable: true,
            margin: new go.Margin(5, 6, 3, 6),

            // 添加编辑完成事件
            textEdited: (textBlock, oldText, newText) => {
              const link = textBlock.part; // 获取所属的 Link
              if (link) {
                const linkData = link.data;
                if (linkData) {
                  if (checkNameUnique(newText, "link", linkData.key)) {
                    link.diagram.model.setDataProperty(linkData, "linkName", newText);
                    link.diagram.model.setDataProperty(linkData, "text", newText);
                  } else {
                    link.diagram.model.setDataProperty(linkData, "text", oldText);
                    messageApi.open({
                      type: "error",
                      content: "流股名称重复",
                    });
                  }
                }
              }
            },
          },
          new go.Binding("text").makeTwoWay(),
          new go.Binding("font", "fontSize").makeTwoWay(),
          new go.Binding("stroke", "textColor").makeTwoWay(),
        ),
      ),
    );

    // 监听链接绘制完成事件
    diagram.addDiagramListener("LinkDrawn", (e) => {
      const link = e.subject; // go.Link 对象
      const linkData = link.data; // 链接对应的数据对象
      if (linkData) {
        const currentText = linkData.text || "";
        diagram.model.setDataProperty(linkData, "linkName", currentText);
      }
    });

    diagram.addDiagramListener("ObjectContextClicked", (e) => {
      e.handled = true;
      e.diagram.currentTool.stopTool();

      // // 获取点击的对象
      // const clickedObj = e.subject.part;

      // // 如果点击的是链接，设置当前管道并显示右键菜单
      // if (clickedObj instanceof go.Link) {
      //   const linkData = clickedObj.data;
      //   setCurTube(linkData);

      //   // 手动触发右键菜单显示，使用viewPoint而不是documentPoint
      //   if (menuRef.current && diagram) {
      //     // 使用viewPoint获取视图坐标，这样菜单位置会正确匹配图表视图
      //     const mousePt = diagram.lastInput.viewPoint;

      //     const menu = menuRef.current;
      //     menu.style.position = "absolute";
      //     menu.style.left = mousePt.x + "px";
      //     menu.style.top = mousePt.y + "px";
      //     menu.style.zIndex = "1000";
      //     menu.style.display = "block";

      //     // 确保菜单不超出视口范围
      //     const rect = menu.getBoundingClientRect();
      //     if (rect.right > window.innerWidth) {
      //       menu.style.left = mousePt.x - rect.width + "px";
      //     }
      //     if (rect.bottom > window.innerHeight) {
      //       menu.style.top = mousePt.y - rect.height + "px";
      //     }
      //   }
      // }
    });

    // 添加全局点击事件监听，点击菜单外部时隐藏菜单
    document.addEventListener("click", (e: any) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        menuRef.current.style.display = "none";
      }
    });
    diagram.addDiagramListener("AnimationFinished", () => {
      diagram.zoomToFit();
    });
    //点击
    diagram.addDiagramListener("ObjectSingleClicked", () => {
      if (diagram.selection.first()) {
        const node = diagram.selection.first().ub;
        console.log(node);
        console.log(JSON.parse(diagram.model.toJson()));
      }
    });
    //双击
    diagram.addDiagramListener("ObjectDoubleClicked", (e) => 
    {
      //高亮连接线背景色
      const node = diagram.selection.first().ub;
      if (!node) return;
      if(node.nodeName!==undefined)
      {
        const allLinks = diagram.model.linkDataArray;
        allLinks.forEach((link: any) => 
        {
          changeLinkBackground(link, "transparent");
        });
        const nodeKey = node.key;
        const relatedLinks = allLinks.filter((link: any) => link.from === nodeKey || link.to === nodeKey);
        relatedLinks.forEach((link: any) => 
        {
          changeLinkBackground(link, "#85e97c"); //高亮颜色
        });
      }
      else if(node.linkName!==undefined)
      {
        const allLinks = diagram.model.linkDataArray;
        allLinks.forEach((link: any) => 
        {
          changeLinkBackground(link, "transparent");
        });
        changeLinkBackground(node, "#85e97c"); //高亮颜色
      }
      openInputParams(diagram);
    });

    // setDiagrams(diagram)
    return diagram;
  };

  const changeTube = (diagram: go.Diagram, tube: any, type: any) => {
    // diagram.model.setDataProperty(tube, "lineColor1", "purple");
    diagram.model.assignAllDataProperties(tube, {
      lineColor1: tubeColorSet[type][0],
      lineColor2: tubeColorSet[type][1],
      lineColor3: tubeColorSet[type][2],
    });
    // console.log(JSON.parse(diagram.model.toJson()));
    // diagram.model=go.Model.fromJson(JSON.parse(diagram.model.toJson()));
  };

  const changeLineWidth = (factor: number) => {
    const diagram = diagramInstance.current;
    if (!diagram) return;
    const selected = diagram.selection.first();
    let linkData = null;
    if (selected instanceof go.Link) {
      linkData = selected.data;
    } else if (curTube) {
      // 如果没有选中但 curTube 存在，通过数据查找链接
      const link = diagram.findLinkForData(curTube);
      if (link) linkData = curTube;
    }
    if (!linkData) return;

    let currentWidth = linkData.strokeWidth;
    if (currentWidth === undefined) currentWidth = 2; // 默认线宽
    let newWidth = currentWidth * factor;
    //连接线宽度范围1~500
    newWidth = Math.min(Math.max(newWidth, 1), 500);
    diagram.model.setDataProperty(linkData, "strokeWidth", newWidth);
  };

  const changeArrowScale = (factor: number) => {
    const diagram = diagramInstance.current;
    if (!diagram) return;
    const selected = diagram.selection.first();
    let linkData = null;
    if (selected instanceof go.Link) {
      linkData = selected.data;
    } else if (curTube) {
      linkData = curTube;
    }
    if (!linkData) return;

    let currentScale = linkData.arrowScale;
    if (currentScale === undefined || currentScale === null) currentScale = 10;
    let newScale = currentScale * factor;
    //箭头尺寸范围1~1000
    newScale = Math.min(Math.max(newScale, 1), 1000);
    diagram.model.setDataProperty(linkData, "arrowScale", newScale);
  };

  const changeLineColor = (color: string) => {
    const diagram = diagramInstance.current;
    if (!diagram) return;

    // 获取当前选中的元素
    const selected = diagram.selection.first();
    let linkData = null;

    // 如果选中的是连接线，则使用其数据；否则尝试使用 curTube（通过右键菜单设置）
    if (selected instanceof go.Link) {
      linkData = selected.data;
    } else if (curTube) {
      linkData = curTube;
    }

    // 更新连接线的颜色
    if (linkData) {
      diagram.model.setDataProperty(linkData, "lineColor", color);
    }
  };

  const changeFontSize = (delta: number) => {
    const diagram = diagramInstance.current;
    if (!diagram) return;
    const selected = diagram.selection.first();
    if (!selected) return;

    if (selected instanceof go.Node) {
      // 修改节点文字大小
      const data = selected.data;
      let currentSize = data.fontSize;
      if (currentSize === undefined || currentSize === null) currentSize = "12pt Lato, sans-serif"; // 默认 48pt
      let newSize = parseFloat(currentSize) + delta;
      // 限制6~1000pt
      newSize = Math.min(Math.max(newSize, 6), 1000);
      diagram.model.setDataProperty(data, "fontSize", newSize + "pt Lato, sans-serif");
    } else if (selected instanceof go.Link) {
      // 修改链接文字大小
      const data = selected.data;
      let currentSize = data.fontSize;
      if (currentSize === undefined || currentSize === null) currentSize = "12pt Lato, sans-serif"; // 默认 22pt
      let newSize = parseFloat(currentSize) + delta;
      // 限制6~60pt
      newSize = Math.min(Math.max(newSize, 6), 1000);
      diagram.model.setDataProperty(data, "fontSize", newSize + "pt Lato, sans-serif");
    }
  };

  const changeTextBackground = (color: string) => {
    const diagram = diagramInstance.current;
    if (!diagram) return;
    const selected = diagram.selection.first();
    if (!selected) return;
    let nodeData = null;
    if (selected instanceof go.Node) {
      nodeData = selected.data;
    } else if (curTube) {
      nodeData = curTube;
    }

    // 更新文字背景色
    if (nodeData) {
      diagram.model.setDataProperty(nodeData, "textBackground", color);
    }
  };

  const changePoint = (dx: number, dy: number) => {
    const diagram = diagramInstance.current;
    if (!diagram) return;
    const selected = diagram.selection.first();
    if (!(selected instanceof go.Node)) return;
    const data = selected.data;
    if (!data) return;

    let point = data.point;
    if (!point || !Array.isArray(point)) point = [0.5, 1.2]; // 默认位置

    let newX = point[0] + dx;
    let newY = point[1] + dy;
    // 限制范围：X 0~1，Y 0~2
    // newX = Math.min(Math.max(newX, 0), 1);
    // newY = Math.min(Math.max(newY, 0), 2);

    diagram.model.setDataProperty(data, "point", [newX, newY]);
  };

  const changeTextColor = (color: string) => {
    const diagram = diagramInstance.current;
    if (!diagram) return;
    const selected = diagram.selection.first();
    if (!selected) return;
    let targetData = null;
    if (selected instanceof go.Node || selected instanceof go.Link) {
      targetData = selected.data;
    } else if (curTube) {
      targetData = curTube;
    }
    // 更新文字颜色
    if (targetData) {
      diagram.model.setDataProperty(targetData, "textColor", color);
    }
  };

  const saveParams = () => {
    console.log("localParamValues:", localParamValues);

    if (diagramInstance.current) {
      const selectedPart = diagramInstance.current.selection.first();
      if (selectedPart) {
        if (selectedPart.data) {
          const partData = selectedPart.data;
          //更新图元数据
          diagramInstance.current?.model.setDataProperty(partData, "ParamValues", localParamValues);

          setModalVisible(false);
          setModalParams(null);
          setLocalParamValues({});
        } else {
          messageApi.open({
            type: "error",
            content: "保存失败",
          });
        }
      } else {
        messageApi.open({
          type: "error",
          content: "保存失败",
        });
      }
    } else {
      messageApi.open({
        type: "error",
        content: "保存失败",
      });
    }
  };

  const saveField = () => {
    if (diagramInstance.current) {
      const selectedPart = diagramInstance.current.selection.first();
      if (selectedPart) {
        const partData = selectedPart.data;
        //更新图元数据
        Object.entries(localFormData).forEach(([key, value]) => {
          diagramInstance.current?.model.setDataProperty(partData, value.engName, value.value);

          //特殊处理
          if (value.engName === "linkName") {
            diagramInstance.current?.model.setDataProperty(partData, "text", value.value);
          }
          if (value.engName === "nodeName") {
            diagramInstance.current?.model.setDataProperty(partData, "text", value.value);
          }
        });

        setModal2Data(null);
        setLocalFormData({});
      }
    }
  };

  const saveMaterials = () => {
    if (diagramInstance.current) {
      const selectedPart = diagramInstance.current.selection.first();
      if (selectedPart) {
        const partData = selectedPart.data;

        let newMaterialsData = {};
        Object.entries(localMaterialsData).forEach(([key, value]) => {
          newMaterialsData[key] = {
            molar_frac: value.molar_frac,
            desValue:value.desValue,
            cas: value.cas,
            name: value.name,
            chineseName: value.chineseName,
          };
        });
        diagramInstance.current?.model.setDataProperty(partData, "materials", newMaterialsData);

        setMaterialsData(null);
        setLocalMaterialsData({});
      }
    }
  };

  const openInputParams = (diagram: any) => {
    const node = diagram.selection.first().ub;
    if (node.elementName !== undefined) {
      let name = node.elementName;
      let type = node.type;
      let params = [];

      //元件基础数据
      let newModal2Data = {
        元件名称: { value: node.nodeName, engName: "nodeName", show: true },
        物性计算方法: {
          value: node.physical_method !== undefined ? node.physical_method : "NRTL",
          engName: "physical_method",
          show: true,
          enum: [
            { label: "NRTL-RK", value: "NRTL" },
            { label: "SRK", value: "SRK" },
          ],
        },
        相态: {
          value: node.phase !== undefined ? node.phase : "L",
          engName: "phase",
          show: true,
          enum: [
            { label: "L-液相", value: "L" },
            { label: "V-汽相", value: "V" },
            { label: "VL-汽液两相", value: "VL" },
          ],
        },
        计算模式: {
          value: node.mode !== undefined ? node.mode : "TP",
          engName: "mode",
          show: true,
          enum: [
            { label: "TP-温压闪蒸", value: "TP" },
            { label: "VP-汽化率压力闪蒸", value: "VP" },
            { label: "HP-压焓闪蒸", value: "HP" },
          ],
        },
      };

      //元件参数
      if (element.filter((item: any) => item.typeID == type).length > 0) {
        params = element.filter((item: any) => item.typeID == type)[0].params;
      }
      if (elementsDatas[type] !== undefined) {
        if (elementsDatas[type].filter((item: any) => item.name == name).length > 0) {
          let extraParams = elementsDatas[type].filter((item: any) => item.name == name)[0].params;
          if (extraParams.length > 0) {
            params = params.concat(extraParams);
          }
        }
      }
      //根据p_type找单位
      for (let i = 0; i < params.length; i++) {
        if (params[i].p_type) {
          if (unitMap[params[i].p_type]) {
            params[i].p_unit = unitMap[params[i].p_type];
          }
        }
      }

      //排序，有子的放在最下面
      params = [
        ...params.filter((item) => !item.hasOwnProperty("p_children")),
        ...params.filter((item) => item.hasOwnProperty("p_children")),
      ];

      if (params.length > 0 && Object.keys(newModal2Data).length > 0) {
        setModalParams(params);
        setModal2Data(newModal2Data);
        setSelectElement(node.text ? node.text : "");
        setModalVisible(true);

        console.log("params:", params);
        console.log("modal2Data:", newModal2Data);
        console.log("diagram:", JSON.parse(diagram.model.toJson()));
      } else {
        messageApi.open({
          type: "error",
          content: "配置文件参数长度有误",
        });
      }
    } else if (node.linkName !== undefined) {
      //流股基础数据
      let newModal2Data = {
        流股名称: { value: node.linkName, engName: "linkName", show: true },
      };

      //流股组分摩尔分率
      let newMaterialsData = {};
      for (let i = 0; i < globalData.materials.length; i++) {
        let name = globalData.materials[i].formula;
        let newMaterialsDataValue = {
          molar_frac: node?.materials?.[name]?.molar_frac ? node?.materials?.[name].molar_frac : (materialsValueMap[name]?materialsValueMap[name]:""),
          desValue:node?.materials?.[name]?.desValue ? node?.materials?.[name].desValue : (materialsValueMap[name]?materialsValueMap[name]:""),
          cas: globalData.materials[i].cas_code,
          name: globalData.materials[i].formula,
          chineseName: globalData.materials[i].name,
        };
        newMaterialsData[name] = newMaterialsDataValue;
      }

      //流股参数
      let params = streamsBasicParams;
      if (params.length > 0 && Object.keys(newModal2Data).length > 0) {
        setModalParams(params);
        setModal2Data(newModal2Data);
        setMaterialsData(newMaterialsData);
        setSelectElement(node.text ? node.text : "");
        setModalVisible(true);

        console.log("params:", params);
        console.log("modal2Data:", newModal2Data);
        console.log("materialsData:", newMaterialsData);
      } else {
        messageApi.open({
          type: "error",
          content: "配置文件参数长度有误",
        });
      }
    } else {
      messageApi.open({
        type: "error",
        content: "元件/流股异常",
      });
    }
  };

  // 校验名称唯一性
  const checkNameUnique = (
    name: string,
    type: "node" | "link" | "group",
    excludeKey?: string,
  ): boolean => {
    if (!diagramInstance.current) return true;
    const model = diagramInstance.current.model;
    if (type === "node") {
      const nodeDataArray = model.nodeDataArray;
      for (const node of nodeDataArray) {
        if (name !== "") {
          if (node.nodeName === name && node.key !== excludeKey) {
            return false;
          }
        }
      }
    } else if (type === "link") {
      const linkDataArray = (model as go.GraphLinksModel).linkDataArray;
      for (const link of linkDataArray) {
        if (name !== "") {
          if (link.linkName === name && link.key !== excludeKey) {
            return false;
          }
        }
      }
    } else if (type === "group") {
      const nodeDataArray = model.nodeDataArray;
      for (const node of nodeDataArray) {
        if (node.isGroup && node.keywords === name && node.key !== excludeKey) {
          return false;
        }
      }
    }
    return true;
  };

  const getRelatedLinks = (nodeKey: string, direction: "in" | "out") => {
    if (!diagramInstance.current) return [];
    const model = diagramInstance.current.model;
    const linkDataArray = (model as go.GraphLinksModel).linkDataArray;
    return linkDataArray.filter((link) => {
      if (direction === "in") return link.to === nodeKey;
      return link.from === nodeKey;
    });
  };
  
  const getRelatedLinks2 = (nodeKey: string, direction: "cold" | "hot") => 
  {
    if (!diagramInstance.current) return [];
    const model = diagramInstance.current.model;
    const linkDataArray = (model as go.GraphLinksModel).linkDataArray;
    let type = direction==="cold"?"冷流股":"热流股";
    return linkDataArray.filter((link) => 
    {
      return link.from === nodeKey && link.ParamValues?.["流股属性"]?.value===type;
    });
  };

  const changeLinkBackground = (linkData: any, color: string) =>
  {
    const diagram = diagramInstance.current;
    if (!diagram) return;
    diagram.model.setDataProperty(linkData, "linkBgColor", color);
  }

  const clearAllLinkHighlights = () => 
  {
    const diagram = diagramInstance.current;
    if (!diagram) return;
    const allLinks = diagram.model["linkDataArray"];
    allLinks.forEach((link: any) => 
    {
      changeLinkBackground(link, "transparent");
    });
  };

  useImperativeHandle(props.diagramsRef, () => 
  ({
    clearAllLinkHighlights,
  }));

  return (
    <>
      {contextHolder}
      {dataSource && (
        <div id="editor" style={{ position: "relative" }}>
          <ReactDiagram
            initDiagram={() => {
              // 创建diagram实例

              const diagram: any = $(go.Diagram, {
                allowMove: true,
                "commandHandler.archetypeGroupData": {
                  keywords: "Group",
                  isGroup: true,
                  color: "blue",
                },
                "undoManager.isEnabled": true,
                // 确保滚轮缩放功能正常工作
                "toolManager.mouseWheelBehavior": go.ToolManager.WheelZoom,
                "linkingTool.isUnconnectedLinkValid": true,
                "relinkingTool.isUnconnectedLinkValid": true,
                // 启用自动平移和缩放功能
                // "toolManager.dragSelectingTool.isEnabled": true,
                scrollMode: go.Diagram.InfiniteScroll,
                isReadOnly: settings.readonly,
                // 确保允许链接操作
                allowLink: true,
                allowRelink: true,
                // 添加初始事件监听器
                initialContentAlignment: go.Spot.Center,
                contextMenu: null,
                // 确保图表使用正确的坐标系统和缩放范围
                // scale: 1.0,
                // minScale: 0.1,
                // maxScale: 5.0
              });

              // 初始配置由updateDiagramReadOnlyState函数统一管理

              // 设置模板和模型属性
              setupTemplates(diagram);

              // 调用初始化回调函数，将diagram实例传递给父组件
              onDiagramInitialized(diagram);

              // 设置初始只读状态
              updateDiagramReadOnlyState(diagram, settings.readonly);

              return diagram;
            }}
            divClassName="diagramArea"
            nodeDataArray={dataSource.nodeDataArray || []}
            linkDataArray={dataSource.linkDataArray || []}
            // modelData={{"position": "0 0"}}
            // 添加onModelChange属性以确保模型变化时正确更新
            onModelChange={(e) => {
              // 当模型变化时，可以在这里添加额外的处理逻辑
              console.log("Model changed:", e);
            }}
            style={{ height: pageHeight, border: "0px solid #BBB", margin: 0 }}
          />

          <div
            ref={overviewContainerRef}
            style={{
              position: "absolute",
              top: 20,
              right: 20,
              width: 150,
              height: 100,
              backgroundColor: "#FFF",
              border: "1px solid #ccc",
              zIndex: 1000,
              display: overview ? "block" : "none",
            }}
          />
        </div>
      )}
      <div ref={menuRef} style={{ position: "absolute", zIndex: 1000, display: "none" }}>
        <ul className="nodeMenu">
          <li id="changeTubeType" className="link">
            {isLinkSelected && (
              <div
                className="changeTubeType"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  background: "#FFF",
                  border: "1px solid #BBB",
                }}
              >
                {/* <Button 
                  onClick={() =>{if(diagramInstance.current){openInputParams(diagramInstance.current);}}}
                  type="text"
                  style={{marginTop:10,marginBottom:10,width:100,height:40,borderRadius:0}}
              >参数信息</Button> */}
                <div>
                  <ColorPicker
                    onChange={(color) => {
                      changeLineColor(color.toHexString());
                    }}
                  >
                    <Button
                      type="text"
                      style={{
                        marginTop: 10,
                        marginBottom: 10,
                        width: 120,
                        height: 40,
                        borderRadius: 0,
                      }}
                    >
                      流股颜色
                    </Button>
                  </ColorPicker>
                </div>
                <div>
                  <ColorPicker
                    onChange={(color) => {
                      changeTextColor(color.toHexString());
                    }}
                  >
                    <Button
                      type="text"
                      style={{
                        marginTop: 10,
                        marginBottom: 10,
                        width: 120,
                        height: 40,
                        borderRadius: 0,
                      }}
                    >
                      文字颜色
                    </Button>
                  </ColorPicker>
                </div>
                <Button
                  onClick={() => {
                    changeLineWidth(1.5);
                  }}
                  type="text"
                  style={{
                    marginTop: 10,
                    marginBottom: 10,
                    width: 120,
                    height: 40,
                    borderRadius: 0,
                  }}
                >
                  增大线宽
                </Button>
                <Button
                  onClick={() => {
                    changeLineWidth(0.5);
                  }}
                  type="text"
                  style={{
                    marginTop: 10,
                    marginBottom: 10,
                    width: 120,
                    height: 40,
                    borderRadius: 0,
                  }}
                >
                  减小线宽
                </Button>
                <Button
                  onClick={() => {
                    changeFontSize(1);
                  }}
                  type="text"
                  style={{
                    marginTop: 10,
                    marginBottom: 10,
                    width: 120,
                    height: 40,
                    borderRadius: 0,
                  }}
                >
                  增大文字尺寸
                </Button>
                <Button
                  onClick={() => {
                    changeFontSize(-1);
                  }}
                  type="text"
                  style={{
                    marginTop: 10,
                    marginBottom: 10,
                    width: 120,
                    height: 40,
                    borderRadius: 0,
                  }}
                >
                  减小文字尺寸
                </Button>
                <Button
                  onClick={() => {
                    changeArrowScale(1.5);
                  }}
                  type="text"
                  style={{
                    marginTop: 10,
                    marginBottom: 10,
                    width: 120,
                    height: 40,
                    borderRadius: 0,
                  }}
                >
                  增大箭头
                </Button>
                <Button
                  onClick={() => {
                    changeArrowScale(0.5);
                  }}
                  type="text"
                  style={{
                    marginTop: 10,
                    marginBottom: 10,
                    width: 120,
                    height: 40,
                    borderRadius: 0,
                  }}
                >
                  减小箭头
                </Button>

                {/* 此处不知道有什么用，但是先注释掉留着 */}
                {/* <div className="ctubeT">更改管道：</div>
              {Object.keys(tubeColorSet).map((item: string, index: number) => {
                return (
                  <div
                    className="s_item"
                    onClick={() =>
                      diagramInstance.current &&
                      changeTube(diagramInstance.current, curTube, item)
                    }
                  >
                    {item}
                  </div>
                )
              })} */}
              </div>
            )}
            {!isLinkSelected && (
              <div
                className="changeTubeType"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  background: "#FFF",
                  border: "1px solid #BBB",
                }}
              >
                <div>
                  <ColorPicker
                    onChange={(color) => {
                      changeTextBackground(color.toHexString());
                    }}
                  >
                    <Button
                      type="text"
                      style={{
                        marginTop: 10,
                        marginBottom: 10,
                        width: 120,
                        height: 40,
                        borderRadius: 0,
                      }}
                    >
                      文字背景色
                    </Button>
                  </ColorPicker>
                </div>
                <div>
                  <ColorPicker
                    onChange={(color) => {
                      changeTextColor(color.toHexString());
                    }}
                  >
                    <Button
                      type="text"
                      style={{
                        marginTop: 10,
                        marginBottom: 10,
                        width: 120,
                        height: 40,
                        borderRadius: 0,
                      }}
                    >
                      文字颜色
                    </Button>
                  </ColorPicker>
                </div>
                <Button
                  onClick={() => {
                    changeFontSize(4);
                  }}
                  type="text"
                  style={{
                    marginTop: 10,
                    marginBottom: 10,
                    width: 120,
                    height: 40,
                    borderRadius: 0,
                  }}
                >
                  增大文字尺寸
                </Button>
                <Button
                  onClick={() => {
                    changeFontSize(-4);
                  }}
                  type="text"
                  style={{
                    marginTop: 10,
                    marginBottom: 10,
                    width: 120,
                    height: 40,
                    borderRadius: 0,
                  }}
                >
                  减小文字尺寸
                </Button>
                <Button
                  onClick={() => {
                    changePoint(0, -0.1);
                  }}
                  type="text"
                  style={{
                    marginTop: 10,
                    marginBottom: 10,
                    width: 120,
                    height: 40,
                    borderRadius: 0,
                  }}
                >
                  文字上移
                </Button>
                <Button
                  onClick={() => {
                    changePoint(0, 0.1);
                  }}
                  type="text"
                  style={{
                    marginTop: 10,
                    marginBottom: 10,
                    width: 120,
                    height: 40,
                    borderRadius: 0,
                  }}
                >
                  文字下移
                </Button>
                <Button
                  onClick={() => {
                    changePoint(-0.1, 0);
                  }}
                  type="text"
                  style={{
                    marginTop: 10,
                    marginBottom: 10,
                    width: 120,
                    height: 40,
                    borderRadius: 0,
                  }}
                >
                  文字左移
                </Button>
                <Button
                  onClick={() => {
                    changePoint(0.1, 0);
                  }}
                  type="text"
                  style={{
                    marginTop: 10,
                    marginBottom: 10,
                    width: 120,
                    height: 40,
                    borderRadius: 0,
                  }}
                >
                  文字右移
                </Button>
              </div>
            )}
          </li>
        </ul>
      </div>
      
      <style>{`
        .rc-dialog-wrap
        {
          pointer-events: none !important;
        }
        .custom-dialog .rc-dialog-section 
        {
          border-radius: 0 !important;
          padding: 0 !important;
          border: 1px solid #BBB !important;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
        }
        .rc-dialog-body
        {
          pointer-events: auto !important;
          padding: 0 !important;
        }
      `}
      </style>
      <Dialog
        className="custom-dialog"
        closable={false}
        footer={null}
        width={designVisible?460+100:460}
        visible={modalVisible}
        mask={false}
        maskClosable={false}
        onClose={() =>{}}
        modalRender={modal => 
          modal ? (
            <Draggable handle=".dialog-header">
              {modal}
            </Draggable>
          ) : null
        }
        // modalRender={(modal) =>
        //   modal ? (
        //     <Draggable cancel=".ant-input, .ant-select-selector, button, .ant-select-selection-item">
        //       {modal}
        //     </Draggable>
        //   ) : null
        // }
      >
        <div>
          <div className="dialog-header" style={{display:"flex",alignItems: "center",justifyContent:"space-between",height:40,paddingLeft:30,fontSize:20,fontWeight:"bold",color:"#1b6ae7", cursor: 'move',background:"#EEE",borderBottom:"1px solid #BBB"}}>
            {`${selectElement}参数信息`}
            {/* <div style={{marginRight:40}}>
              <button
                onClick={()=>{setDesignVisible(!designVisible);}}
                style={{width:100,height:23,border:designVisible?0:"1px solid #BBB",backgroundColor:designVisible?"#1b6ae7":"#FFF",marginRight:10,fontSize:12,color:designVisible?"#FFF":"#BBB"}}
              >{designVisible?"关闭输入设计值":"打开输入设计值"}</button>
              <button
                onClick={()=>{setFastVisible(true);}}
                style={{width:70,height:23,border:"1px solid #BBB",backgroundColor:"#FFF",fontSize:12,color:"#BBB"}}
              >快捷输入</button>
            </div> */}
          </div>
          <div style={{padding:20}}>
            <ParameterEditor
              localFormData={localFormData}
              setLocalFormData={setLocalFormData}
              modalParams={modalParams}
              localParamValues={localParamValues}
              setLocalParamValues={setLocalParamValues}
              materialsData={materialsData}
              localMaterialsData={localMaterialsData}
              setLocalMaterialsData={setLocalMaterialsData}
              globalData={globalData}
              selectElement={selectElement}
              maxHeight={designVisible?400+200:400}
              designVisible={designVisible}
              fastModalVariable={fastVisible}
              closeFastModal={() => {setFastVisible(false);}}
              saveAbled={(newSaveAbled) => {setSaveAbled(newSaveAbled);}}
            />
          </div>
          <div style={{ height: 32,marginTop:10 }}>
            {(designVisible?(
              <div style={{marginLeft:20,color:"#9e9e9e",fontSize:12}}>
                <WarningOutlined style={{marginRight:5,color:"orange"}}/>
                提示：第一个输入框为计算值，第二个输入框为设计值
              </div>
            ):null)}
            <button
              onClick={() => {
                {
                  setModalVisible(false);
                  setModalParams(null);
                  setModal2Data(null);
                  setMaterialsData(null);
                  setLocalParamValues({});
                  setLocalFormData({});
                  setLocalMaterialsData({});
                  const diagram = diagramInstance.current;
                  if (diagram) 
                  {
                    const allLinks = diagram.model["linkDataArray"];
                    allLinks.forEach((link: any) => {
                      changeLinkBackground(link, "transparent");
                    });
                  }
                }
              }}
              style={{
                position: "absolute",
                right: 25,
                bottom: 10,
                width: 88,
                height: 32,
                border: 0,
                borderRadius: 5,
                background: "#FF4D4F",
                color: "#FFF",
                fontSize: 14,
              }}
            >
              取消
            </button>
            <button
              onClick={() => {
                if(saveAbled)
                {
                  const selectedPart = diagramInstance.current.selection.first();
                  const partData = selectedPart.data;
                  if (localFormData["元件名称"] && localFormData["元件名称"].value !== "") {
                    if (!checkNameUnique(localFormData["元件名称"].value, "node", partData.key)) {
                      messageApi.open({
                        type: "error",
                        content: "元件名称重复",
                      });
                    } 
                    else 
                    {
                      saveField();
                      saveParams();

                      const diagram = diagramInstance.current;
                      if (diagram) 
                      {
                        const allLinks = diagram.model["linkDataArray"];
                        allLinks.forEach((link: any) => {
                          changeLinkBackground(link, "transparent");
                        });
                      }
                    }
                  } 
                  else if (localFormData["流股名称"] && localFormData["流股名称"].value !== "") 
                  {
                    if (!checkNameUnique(localFormData["流股名称"].value, "link", partData.key)) 
                    {
                      messageApi.open({
                        type: "error",
                        content: "流股名称重复",
                      });
                    } 
                    else 
                    {
                      saveField();
                      saveParams();
                      saveMaterials();

                      const diagram = diagramInstance.current;
                      if (diagram) 
                      {
                        //取消高亮
                        const allLinks = diagram.model["linkDataArray"];
                        allLinks.forEach((link: any) => {
                          changeLinkBackground(link, "transparent");
                        });

                        //判断是否修改连接线颜色
                        const selectedPart = diagramInstance.current.selection.first();
                        if(selectedPart.data["ParamValues"]?.["流股属性"].value==="冷流股")
                        {
                          changeLineColor("#0000FF");
                        }
                        else if(selectedPart.data["ParamValues"]?.["流股属性"].value==="热流股")
                        {
                          changeLineColor("#FF0000");
                        }
                        else if(selectedPart.data["ParamValues"]?.["流股属性"].value==="无")
                        {
                          changeLineColor("#000");
                        }
                      }
                    }
                  } else {
                    messageApi.open({
                      type: "error",
                      content: "请填写元件/流股名称",
                    });
                  }
                }
                else
                {
                  messageApi.open
                  ({
                    type:"error",
                    content:"保存失败：数据非法",
                  });
                }
              }}
              style={{
                position: "absolute",
                right: 138,
                bottom: 10,
                width: 88,
                height: 32,
                border: 0,
                borderRadius: 5,
                background: "#1b6ae7",
                color: "#FFF",
                fontSize: 14,
              }}
            >
              保存
            </button>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default Component;
